// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7d54f950","453":"30f7b828","455":"59e71be0","533":"af52b785","615":"64e38296","977":"3089f0c4"}[chunkId] + ".chunk.js";
};